import LogOutIcon from '@atlaskit/icon/core/log-out';
import * as React from 'react';

export function SvgLogOut() {
  return <LogOutIcon label="" testId="ads-refreshed-icon" />;
}
